import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"
import { useBookId } from "@/hooks/use-book-id"

import { fetchCompanyNoteTemplates } from "./api"

export function useFetchCompanyNoteTemplates(options?: { enabled?: boolean; scope?: "company" | "book" }) {
  const getContext = useApiContext()
  const bookId = useBookId()
  const scopeSegment = options?.scope === "company" ? "company" : (bookId ?? "company")

  const queryKey = ["company-note-templates", scopeSegment]

  return useQuery({
    queryKey,
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchCompanyNoteTemplates(context, options?.scope ? { scope: options.scope } : undefined)
    },
    enabled: options?.enabled ?? true,
    retry: false,
  })
}
